/// <reference path="../jquery/jquery.d.ts" />
/// <reference path="sxcframe.ts" />
/// <reference path="./d/app.d.ts" />

module Sxc
{
	interface MyAccountMenuEntry
	{
		name: string;
		title: string;
		hidden?: boolean;
	}

	interface MyAccountParams
	{
		title: string;
		errorMessage: string;
		errorTitle: string;
		menu: Array<MyAccountMenuEntry>
	}

	export class MyAccount
	{
		private frame         : WindowManager.Window;
		private $root         : JQuery;
		private $error        : JQuery;
		private $sidebar      : JQuery;
		private $loading      : JQuery;
		private $content      : JQuery;
		private $contentInner : JQuery;

		private xhrLoading : boolean;
		private lastXHR : any;
		private currentPanel: string;
		private visible: boolean =  false;

		constructor(private params: MyAccountParams)
		{
			this.createFrame();
			this.fillMenu();
			this.initEvents();
		}

		createFrame()
		{
			this.frame = new WindowManager.Window("myaccount");
			this.frame.setTitle(this.params.title);

			var template = "<div class=\"myaccount-frame\">\n\t\n\t<div class=\"sidebar\">\n\t</div>\n\t\n\t<div class=\"content-wrapper\">\n\t\t<div class=\"content\">\n\t\t\t<div class=\"content-inner\"></div>\n\t\t</div>\n\t\t<div class=\"content-loading\">\n\t\t\t<span class=\"loading-animation-1\"></span>\n\t\t</div>\n\t\t<div class=\"content-error\">\n\t\t\t<h2></h2>\n\t\t\t<i class=\"fa fa-bug\"></i>\n\t\t\t<span class=\"text\"></span>\n\t\t</div>\n\t</div>\n\t\n</div>";

			this.$root = $(template);
			this.$root = $(template);
			this.$loading = this.$root.find(".content-loading");
			this.$content = this.$root.find(".content");
			this.$contentInner = this.$root.find(".content-inner");
			this.$sidebar = this.$root.find(".sidebar");
			this.$error = this.$root.find(".content-error");
			this.$error.find("h2").text(this.params.errorTitle);
			this.$error.find(".text").text(this.params.errorMessage);
			this.frame.setContent(this.$root);
		}

		fillMenu()
		{
			var $ul = $("<ul/>");

			for(var i=0; i < this.params.menu.length; i++)
			{
				var item = this.params.menu[i];
				if (item.hidden) continue;

				$("<li/>")
					.attr("data-name", item.name)
					.text(item.title)
					.appendTo($ul);
			}

			this.$sidebar.empty().append($ul);
		}

		initEvents()
		{
			this.$root.find(".sidebar").on("click", "li", (e) =>
			{
				var $li = $(e.currentTarget);
				this.load($li.data("name"));
			});

			this.frame.onShow(() =>
			{
				// $(window).on("resize.myAccount", () => {this.fixButtons();});
				this.visible = true;
			});

			this.frame.onHide(() => {
				// $(window).off("resize.myAccount");
				this.$contentInner.empty();
				this.visible = false;
			});

			$("#header").find(".userMenu .settings").on("click", "a", (e) =>
			{
				var $link = $(e.currentTarget);
				var url:string = $link.attr("href");
				if (url.substr(0,11) === "/myaccount/") {
					e.preventDefault();
					this.show(url.substr(11));
				}
			});

			this.$content.on("click", "form button[type=submit]", (e) =>
			{
				var $button = $(e.currentTarget);
				var $form   = $button.closest("form");

				var $hidden = $form.find("input[type=hidden][name=" + $button.attr("name") + "]");

				if (!$hidden.length) {
					$hidden = $("<input type=\"hidden\" />").appendTo($form);
				}

				$hidden
					.attr("name", $button.attr("name"))
					.attr("value", $button.attr("value"));
			});


			this.$content.on("submit", "form", (e) =>
			{
				e.preventDefault();
				var $form = $(e.currentTarget);
				debug.log("[Settings][event]", "form.submit:", $form.serialize());
				this.load(this.currentPanel, $form);
			});
		}

		switchSideBar(panel)
		{
			this.$sidebar.find("li")
				.removeClass("active")
				.filter("[data-name=" + panel + "]")
				.addClass("active");
		}

		hide() {
			this.$content.off("DOMSubtreeModified.myAccount");
			this.frame.onHide(() => {
				$("body").removeClass("noscroll");
			});
			this.frame.hide();
			this.$contentInner.empty();
		}

		show(panel: string)
		{
			debug.log("[Settings][show]", "panel:", panel);

			this.frame.onShow(() => {
				$("body").addClass("noscroll");
				this.frame.getRoot().css("display", "flex");
			});
			this.frame.show();

			this.$content.on("DOMSubtreeModified.myAccount", () =>
			{
				setTimeout(() => {this.fixButtons();}, 0);
			});

			this.load(panel);
		}

		load(panel: string, $form: JQuery = null)
		{
			debug.log("[Settings][load]", "panel:", panel);
			if ($form) debug.log("[Settings][load]", "form:", $form.serialize());
			this.switchSideBar(panel);
			this.$error.hide();
			this.$loading.show();

			this.xhrLoading = true;

			var url = "/ajax/myaccount/" + panel;

			this.lastXHR = $.ajax({
				"url": url,
				"dataType": "json",
				"data": $form ? $form.serialize() : null,
				"type": $form ? "POST" : "GET"
			})
				.done((r) => {
					this.onLoadSuccess(panel, r);
				})
				.fail(() => {
					this.onLoadError(panel);
				})
				.always(() => {
					this.xhrLoading = false;
				});
		}

		fixButtons()
		{
			if (!this.visible) return;
			var ciHeight = this.$contentInner.height();
			var cHeight = this.$content.height();
			this.$content.find(".buttons")[ cHeight > ciHeight ? "addClass" : "removeClass" ]("sticky");
		}

		onLoadError(panel)
		{
			this.switchSideBar(this.currentPanel);
			this.$content.hide();
			this.$loading.hide();
			this.$error.show();
		}

		onLoadSuccess(panel, r)
		{
			if (!r) {
				this.onLoadError(panel);
			} else if (r.html) {
				this.$loading.hide();
				this.$content.show();
				this.$contentInner.empty().html(r.html);
				this.currentPanel = panel;
			} else if (r.redirect) {
				location.href = r.redirect;
			} else {
				this.onLoadError(panel);
			}
		}
	}
}

